import {subMonths, subYears, format} from 'date-fns'

export const oneMonthAgo = (date: Date): string => {
  return format(subMonths(date, 1), 'yyyy-MM-dd')
}

export const threeMonthsAgo = (date: Date): string => {
  return format(subMonths(date, 3), 'yyyy-MM-dd')
}

export const oneYearAgo = (date: Date): string => {
  return format(subYears(date, 1), 'yyyy-MM-dd')
}
